import { useEffect } from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import {
  authCheck,
  refreshUserInfo,
  selectAuthToken,
  authSessionInvalid,
  selectAuthUserIsLoggedIn,
  selectAuthDirectLoginLoading,
  AuthCheckActionArgs,
} from '../../store'
import { withActions, WithActionsProps } from '@cibo/ui'
import {
  REQUEST_ERROR_UNAUTHORIZED,
  REQUEST_ERROR_NEED_SUBSCRIPTION,
  REQUEST_ERROR_OVER_QUOTA,
} from '@cibo/core'

import { AuthCheck } from './AuthCheck'
import { useQueryClient } from '@tanstack/react-query'

type Props = {
  jwt: string
  loginPending: boolean
  isLoggedIn: boolean
  authCheck(request: AuthCheckActionArgs): void
  refreshUserInfo(): void
  authSessionInvalid(): void
}

const mapStateToProps = (state: any) => ({
  jwt: selectAuthToken(state),
  loginPending: selectAuthDirectLoginLoading(state),
  isLoggedIn: selectAuthUserIsLoggedIn(state),
})

const mapDispatchToProps = {
  authCheck,
  refreshUserInfo,
  authSessionInvalid,
}

const AuthCheckContainer = (props: Props & WithActionsProps) => {
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const { isLoggedIn, loginPending, subscribeAction } = props

  useEffect(() => {
    if (!isLoggedIn) {
      queryClient.clear()
    }
  }, [isLoggedIn])

  const authFlow = (reason: string) => () => {
    if (reason !== REQUEST_ERROR_UNAUTHORIZED) {
      if (!loginPending && !isLoggedIn) {
        navigate('/login', { state: { modal: true, prompt } })
      }
    }
  }

  useEffect(() => {
    subscribeAction(REQUEST_ERROR_UNAUTHORIZED, authFlow)
    subscribeAction(REQUEST_ERROR_NEED_SUBSCRIPTION, authFlow)
    subscribeAction(REQUEST_ERROR_OVER_QUOTA, authFlow)
  }, [])

  return <AuthCheck {...props} />
}

export default connect(mapStateToProps, mapDispatchToProps)(withActions(AuthCheckContainer))
